import React, { useRef, useLayoutEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import gsap from 'gsap';

import { UserStoreContext } from '@common/stores';
import styles from './ButtonHamburger.module.scss';

export const ButtonHamburger = ({ onClick, themeDark, ariaLabel }) => {
  const { motionDisabled } = useContext(UserStoreContext);
  const lines = [useRef(null), useRef(null), useRef(null)];
  const tweens = useRef({
    lines: null,
  });

  const handleMouseEnter = () => {
    if (!motionDisabled) tweens.current.lines.play();
  };

  const handleMouseLeave = () => {
    if (!motionDisabled) tweens.current.lines.reverse();
  };

  useLayoutEffect(() => {
    tweens.current.lines = gsap.timeline({ paused: true });

    tweens.current.lines.to(
      lines.map(line => line.current),
      {
        transformOrigin: 'right',
        scaleX: 0,
        duration: 0.35,
        stagger: -0.1,
        ease: 'power3.in',
      }
    );

    tweens.current.lines.to(
      lines.map(line => line.current),
      {
        transformOrigin: 'left',
        scaleX: 1,
        duration: 0.35,
        stagger: -0.1,
        ease: 'power3.out',
      }
    );

    return () => {
      if (tweens.current.lines) {
        tweens.current.lines.kill();
        tweens.current.lines = null;
      }
    };
  }, []);

  return (
    <button
      type="button"
      aria-label={ariaLabel}
      className={`${styles.button} ${themeDark ? styles.dark : ''}`}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <span className={styles.icon}>
        <span className={styles.line} ref={lines[0]} />
        <span className={styles.line} ref={lines[1]} />
        <span className={styles.line} ref={lines[2]} />
      </span>
    </button>
  );
};

ButtonHamburger.propTypes = {
  onClick: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
  themeDark: PropTypes.bool,
};

ButtonHamburger.defaultProps = {
  themeDark: false,
  ariaLabel: 'Menu',
};
